
define('jsx!components/login-public-tenant/input-username',["react"], function (React)
{
	return React.createClass({
		displayName: "Username",
		getDefaultProps: function ()
		{
			return {
				"username": null,
				"setUsername": function () {},
				"handleEnterKeyUp": function () {},
				"setAuthenticationMethod": function () {},
				"setErrorMessage": function () {},
				"setValidating": function () {},
				"isPebbleGoPortal": false,
				"usernameImage": null
			};
		},
		getInitialState: function ()
		{
			return {
				"username": this.props.username,
				"help_message": null
			};
		},
		handleChangeOnUsername: function (e)
		{
			this.props.setUsername(e.currentTarget.value);
			if (!this.props.isPebbleGoPortal) {
				this.props.hidePasswordInput();
			}
		},
		handleKeyUpOnUsername: function (e)
		{
			if (e.charCode == 13 || e.keyCode == 13 || e.key == 13 || e.which == 13) {
				this.props.handleEnterKeyUp();
			}
		},
		render: function ()
		{
			var classNames = ['form-group'];

			if (this.props.isPebbleGoPortal) {
				classNames.push("username");

				return (
					React.createElement("div", {className: classNames.join(" ")}, 
						React.createElement("span", {className: "username-header"}, "Enter Username"), 
						React.createElement("input", {
							type: "text", 
							className: "username-input", 
							name: "username", 
							placeholder: "Username", 
							id: "input-username", 
							value: this.props.username, 
							onChange: this.handleChangeOnUsername, 
							onKeyUp: this.handleKeyUpOnUsername, 
							"aria-label": "username", 
							autoFocus: true}
							), 
						React.createElement("img", {className: "username-icon-graphic", src: this.props.usernameImage, alt: "username-icon"})
					)
				);
			} else {
				return (
					React.createElement("div", {className: classNames.join(" ")}, 
						React.createElement("input", {
							type: "text", 
							className: "form-control", 
							name: "username", 
							placeholder: "Enter your E-Mail / Username", 
							id: "input-username", 
							value: this.props.username, 
							onChange: this.handleChangeOnUsername, 
							onKeyUp: this.handleKeyUpOnUsername, 
							"aria-label": "username", 
							autoFocus: true}
							)
					)
				);
			}

		}
	});
});
